<div class="w-full text-secondary dark:text-secondary-900 mb-3">
	<div class="relative">
		<textarea
			#textarea
			[id]="'textarea-' + inputId()"
			[value]="value()"
			[disabled]="disabled()"
			class="rounded bg-white border border-secondary-300 w-full duration-300 py-2 px-3 min-h-10 max-h-20 focus:border-focus placeholder:text-secondary-400 pr-8 outline-none"
			[placeholder]="placeholder()"
			(input)="onInput($event)"
			(focusout)="onFocusOut()"
			(focusin)="onFocusIn()"
			[class]="{
				'border-success': showSuccess(),
				'!border-error': showError(),
				resize: !resizeDisabled(),
				'resize-none': !resizeDisabled(),
				'resize-y': singleLine(),
			}"
		></textarea>
		@if (showError()) {
			<ui-icon icon="failures" type="error" size="m" class="absolute right-3 top-2.5"></ui-icon>
		}
	</div>
	@if (showError() && errorText()) {
		<p class="text-sm text-error mt-1" data-cy="ui-textarea-error">{{ errorText() }}</p>
	}
</div>
